/**
 * SASS
 */
import '../sass/frontend.scss';

/**
 * Node Modules
 */
import 'slick-carousel';
import 'magnific-popup';

/**
 * Components
 */
import { popup } from './components/popup.js';
import { blocks, heroMedia } from './components/blocks.js';
import { initSlideShows } from './components/slideshow.js';
import { menuWalker, mobileMenu, menuDrilldown, scrollingNav, menuResize } from './components/navigation.js';
import { menuSearch, directoryFilter, customSelect, filtersToggle, scrollNavToggle } from './components/toggle.js';
import { accordionAnim } from './components/accordion.js';
import { videoPlyr } from './components/video.js';
import { elementAnimation } from './components/animation.js';

/**
 * JS
 */
$(function() {
    popup();
    initSlideShows();
    blocks();
    menuWalker();
    menuSearch();
    mobileMenu();
    menuDrilldown();
    scrollingNav();
    heroMedia();
    accordionAnim();
    videoPlyr();
    elementAnimation();
    directoryFilter();
    customSelect();
    filtersToggle();
    scrollNavToggle();
});

$(document).on('facetwp-loaded', function() {
    // eslint-disable-next-line
    if ( FWP.loaded ) { // Run only after the initial page load
        $('html, body').animate({
            scrollTop: $('.facet-scroll').offset().top // Scroll to the top of the element with class "facetwp-template"
        }, 500);
    }
});

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
let prevWidth = window.innerWidth;
const debounceFunctions = debounce(function() {
    const width = window.innerWidth;
    if (width !== prevWidth) {
        prevWidth = width;
        menuResize();
    }
}, 100);
// eslint-disable-next-line
window.addEventListener('resize', function() {
    debounceFunctions();
});

 